import React from "react";
import styled from "styled-components";
import {colourMapping} from "../../idea/IdeaType";
import {subduedTextColour} from "../../../style/styleConsts";
import AuthorIdea from "./AuthorIdea";

const MAX_OPEN_IDEAS_SHOWN = 50;

const Container = styled.div`
    margin-bottom: 10px;
`;

const Direction = styled.div`
    font-weight: bold;
    color: ${props => props.colour};
`;

const IdeasContainer = styled.div`
    margin-left: 10px;
    margin-top: 5px;
`;

export const OpenIdeasList = ({ideas, ideaType, showDetail}) => {
    if (!ideas.length) return null;

    const ideasToDisplay = ideas.slice(0, MAX_OPEN_IDEAS_SHOWN);
    return <Container className={`t-open-${ideaType.toLowerCase()}s`}>
        <Direction colour={colourMapping[ideaType.toUpperCase()]}>{ideaType}s</Direction>
        <IdeasContainer>
            {
                ideasToDisplay.map(idea => <AuthorIdea key={idea.ideaId}
                                                       idea={idea}
                                                       showDetail={showDetail}/>)
            }
        </IdeasContainer>
        <IdeasNotShownWarning ideaCount={ideas.length}/>
    </Container>;
};

const WarningContainer = styled.div`
    margin-top: 1ex;
    margin-left: 14px;
    color: ${subduedTextColour};
`;

const IdeasNotShownWarning = ({ideaCount}) => {
    if (ideaCount <= MAX_OPEN_IDEAS_SHOWN) return null;

    return <WarningContainer className="t-more">
        {(ideaCount - MAX_OPEN_IDEAS_SHOWN) + " older ideas not shown."}
    </WarningContainer>;
};